import React from 'react';
import { Music, BookOpen, User } from 'lucide-react';
import { playClick } from '../../utils/audioUtils';
type HeaderProps = {
  onNavigate: (page: string) => void;
  currentPage: string;
};
export function Header({
  onNavigate,
  currentPage
}: HeaderProps) {
  const handleNavClick = (page: string) => {
    playClick();
    onNavigate(page);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="flex justify-between items-center h-16" data-id="element-40">
          {/* Logo Area */}
          <div className="flex items-center cursor-pointer group" onClick={() => handleNavClick('home')} data-id="element-41">
            <div className="w-10 h-10 bg-[#C41E3A] rounded-full flex items-center justify-center mr-3 transform group-hover:rotate-12 transition-transform duration-300 shadow-md" data-id="element-42">
              <Music className="text-white w-6 h-6" data-id="element-43" />
            </div>
            <div data-id="element-44">
              <h1 className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-45">
                《同唱古诗词》音乐实验室
              </h1>
              <p className="text-xs text-gray-500" data-id="element-46">Ancient Poetry Music Lab</p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex space-x-2" data-id="element-47">
            <button onClick={() => handleNavClick('home')} className={`flex items-center px-4 py-2 rounded-full text-sm font-bold transition-all ${currentPage === 'home' ? 'text-white bg-[#C41E3A] shadow-md' : 'text-gray-600 hover:text-[#C41E3A] hover:bg-red-50'}`} data-id="element-48">
              <Music className="w-4 h-4 mr-2" data-id="element-49" />
              实验室
            </button>
            <button onClick={() => handleNavClick('poems')} className={`flex items-center px-4 py-2 rounded-full text-sm font-bold transition-all ${currentPage === 'poems' ? 'text-white bg-[#177CB0] shadow-md' : 'text-gray-600 hover:text-[#177CB0] hover:bg-blue-50'}`} data-id="element-50">
              <BookOpen className="w-4 h-4 mr-2" data-id="element-51" />
              诗词库
            </button>
            <button onClick={() => handleNavClick('guide')} className={`flex items-center px-4 py-2 rounded-full text-sm font-bold transition-all ${currentPage === 'guide' ? 'text-white bg-[#0C8918] shadow-md' : 'text-gray-600 hover:text-[#0C8918] hover:bg-green-50'}`} data-id="element-52">
              <User className="w-4 h-4 mr-2" data-id="element-53" />
              家长指南
            </button>
          </nav>

          {/* Mobile Menu Button (Placeholder) */}
          <div className="md:hidden" data-id="element-54">
            <button className="p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100" data-id="element-55">
              <span className="sr-only" data-id="element-56">Open menu</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-57">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-58" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>;
}